import React, { useContext } from 'react';
import { Linklist } from '@ktag/styleguide/dist/react';
import { PollDayLink } from 'api/api.types';
import ApiContext from 'api/ApiContext';
import { useTranslation } from 'react-i18next';
import AdditionalResourcesBox from './AdditionalResourcesBox';

interface Props {
  links: PollDayLink[];
  headingLevel?: 2 | 3;
}

const Links = ({ links, headingLevel }: Props) => {
  const { t } = useTranslation('wap');
  const { language } = useContext(ApiContext);

  const sortedLinks = [...links]?.sort((a, b) => {
    if (a.sort_key < b.sort_key) return -1;
    if (a.sort_key > b.sort_key) return 1;
    return 0;
  });

  const formattedLinks = sortedLinks?.map((link) => ({
    linkText: link.label[language],
    icon: { id: 'external' },
    target: {
      url: link.path,
      external: true,
    },
  }));

  return (
    <AdditionalResourcesBox title={t('additional_info')} headingLevel={headingLevel}>
      <Linklist links={formattedLinks} />
    </AdditionalResourcesBox>
  );
};

export default Links;
